import React from "react";
import SubHome from "../components/SubHome";
import "../styles/pages/joinus.css";
import queryString from "query-string";

const JoinUs = () => {
  const mailtoLink = queryString.stringifyUrl({
    url: "mailto:ploesfelix@gmail.com",
    query: {
      subject: "Join Cheffy",
      body: "Hello, I am interested in joining Cheffy!",
    },
  });

  return (
    <>
      <SubHome mainHeading="
Únase a nuestro equipo" listItem="
Únase a nuestro equipo" />
      <div className="privacy-policy-container">
        <div
          className="heading-content-section"
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <h2 className="main-heading">Trabaja Con Nosotros</h2>
          <div
            className="heading-border"
            style={{ marginBottom: "40px" }}
          ></div>
        </div>

        <p>
        En Cheffy, siempre estamos buscando personas apasionadas para unirse a nuestro equipo. ¡Nos encantaría que formes parte, ya sea como Cooker compartiendo tus habilidades culinarias o como parte de nuestro dedicado equipo de soporte!
        </p>
        <p>
        Si estás interesado en formar parte de nuestra innovadora plataforma, simplemente llena el formulario de solicitud y adjunta tu CV. Te animamos a compartir algunas palabras en la descripción sobre por qué crees que serías una gran incorporación a Cheffy.
        </p>
        <p>
        Tus experiencias únicas y tu entusiasmo son lo que hacen vibrante a nuestra comunidad, ¡y estamos ansiosos por saber de ti!
        </p>

        <div className="join-form-box">
          <a
            className="join-btn"
            href={mailtoLink}
            target="_self"
            style={{ textAlign: "center" }}
          >
            Join Us
          </a>
        </div>
      </div>
    </>
  );
};

export default JoinUs;
